// Web (PayPal) prices in the visitor's currency. The server picks the currency
// from the app language and browser region (fallback USD) and charges exactly
// what /paypal/config quotes, so the browser only formats — it never converts.
import { useEffect, useState } from 'react';
import { api } from './api';

const INTL_LOCALE = { en: 'en-GB', no: 'nb-NO', da: 'da-DK', sv: 'sv-SE', de: 'de-DE',
    nl: 'nl-NL', fr: 'fr-FR', es: 'es-ES', it: 'it-IT', pt: 'pt-PT', pl: 'pl-PL' };

export function formatPrice(amount, currency, locale) {
    const value = Number(amount);
    if (amount === '' || amount == null || !Number.isFinite(value) || !currency) return '';
    const whole = Number.isInteger(value);
    try {
        return new Intl.NumberFormat(INTL_LOCALE[locale] || locale || 'en', {
            style: 'currency', currency,
            minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2,
        }).format(value).replace(/ /g, ' ');
    } catch {
        return `${currency} ${amount}`;
    }
}

export function pricingParams(locale) {
    const langs = (typeof navigator !== 'undefined' && navigator.languages) || [];
    return { lang: locale || '', region: Array.from(langs).join(',') };
}

export function savePercent(prices) {
    const monthly = Number(prices?.monthly);
    const yearly = Number(prices?.yearly);
    if (!monthly || !yearly) return 0;
    return Math.round((1 - yearly / 12 / monthly) * 100);
}

const cache = new Map();

export function resetWebPrices() { cache.clear(); }

export function loadWebPrices(locale) {
    const key = locale || '';
    if (!cache.has(key)) {
        cache.set(key, api.get('/paypal/config', { params: pricingParams(locale) })
            .then(({ data }) => ({ currency: data.currency, monthly: data.price_monthly,
                yearly: data.price_yearly, config: data }))
            .catch(() => { cache.delete(key); return null; }));
    }
    return cache.get(key);
}

export function useWebPrices(locale, enabled = true) {
    const [prices, setPrices] = useState(null);
    useEffect(() => {
        if (!enabled) return undefined;
        let live = true;
        loadWebPrices(locale).then(p => { if (live) setPrices(p); });
        return () => { live = false; };
    }, [locale, enabled]);
    return prices;
}
